import { useRoutes } from "react-router-dom";
import PublicLayout from "./layouts/PublicLayout";
import { Helmet } from "react-helmet-async";
import configs from "./configs";
import Notes from "./pages/Notes";
import NoteGuard from "./guards/NoteGuard";
import AuthLayout from "./layouts/AuthLayout";
import AdminLogin from "./pages/private-admin/AdminLogin";
import PrivateRoute from "./auth/AdminPrivateRoute";
import NoteEditNew from "./pages/private-admin/NoteEditNew";
import FormSuccess from "./pages/FormSuccess";
import Edit from "./pages/private-admin/NoteEditNew/Edit";
import NotFound from "./pages/NotFound";
import PrivateLayout from "./layouts/PrivateLayout";
import SavedNotes from "./pages/private-user/SavedNotes";
import Unsubscribe from "./pages/Unsubscribe";
import NoteWorksheet from "./pages/NoteWorksheet";
import ThePaperBrokerLayout from "./layouts/ThePaperBrokerLayout";
import NoteWorksheetSuccess from "./pages/NoteWorksheetSuccess";

const Routes = () => {
  const routing = useRoutes([
    {
      element: <PublicLayout />,
      children: [
        {
          path: "/",
          element: (
            <>
              <Helmet>
                <title>{configs.name}</title>
              </Helmet>
              <Notes />
            </>
          ),
        },
        {
          path: "/notes/:noteID",
          element: (
            <>
              <Helmet>
                <title>{configs.name}</title>
              </Helmet>
              <NoteGuard />
            </>
          ),
        },
        {
          path: "/form-success",
          element: (
            <>
              <Helmet>
                <title>{configs.name}</title>
              </Helmet>
              <FormSuccess />
            </>
          ),
        },
      ],
    },
    {
      element: <AuthLayout />,
      children: [
        {
          path: "/admin/login",
          element: (
            <>
              <Helmet>
                <title>{configs.name}</title>
              </Helmet>
              <AdminLogin />
            </>
          ),
        },
      ],
    },
    {
      element: <PrivateRoute />,
      children: [
        {
          path: "/admin/note/new",
          element: (
            <>
              <Helmet>
                <title>{configs.name}</title>
              </Helmet>
              <NoteEditNew />
            </>
          ),
        },
        {
          path: "/admin/note/edit/:noteID",
          element: (
            <>
              <Helmet>
                <title>{configs.name}</title>
              </Helmet>
              <Edit />
            </>
          ),
        },
      ],
    },
    {
      element: <PrivateLayout />,
      children: [
        {
          path: "/saved-notes",
          element: (
            <>
              <Helmet>
                <title>{configs.name}</title>
              </Helmet>
              <SavedNotes />
            </>
          ),
        },
      ],
    },
    {
      path: "/unsubscribe",
      element: (
        <>
          <Helmet>
            <title>{configs.name}</title>
          </Helmet>
          <Unsubscribe />
        </>
      ),
    },
    {
      path: "*",
      element: (
        <>
          <NotFound />
        </>
      ),
    },
    {
      element: <ThePaperBrokerLayout />,
      children: [
        {
          path: "/online-note-worksheet",
          element: (
            <>
              <Helmet>
                <title>The Paper Broker - Online Note Worksheet</title>
              </Helmet>
              <NoteWorksheet />
            </>
          ),
        },
        {
          path: "/online-note-worksheet-success",
          element: (
            <>
              <Helmet>
                <title>The Paper Broker - Online Note Worksheet Success</title>
              </Helmet>
              <NoteWorksheetSuccess />
            </>
          ),
        },
      ],
    },
  ]);

  return (
    <>
      <Helmet>
        <title>{configs.name || window.location.host}</title>
      </Helmet>
      {routing}
    </>
  );
};

export default Routes;
